import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2, XCircle, ArrowRight } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

function parseHashCode() {
  const h = (window.location.hash || "").replace(/^#/, "");
  const p = new URLSearchParams(h);
  return p.get("code");
}

export default function SupportEnter() {
  const navigate = useNavigate();
  const ended = new URLSearchParams(window.location.search).get("ended") === "1";
  const [state, setState] = useState(ended ? "ended" : "working"); // working | error | ended
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (ended) return;
    const code = parseHashCode();
    // clean the URL immediately so the launch code never lingers in history
    try { window.history.replaceState({}, "", "/support"); } catch { /* ignore */ }
    if (!code) { setState("error"); setMsg("Kein gültiger Zugangscode. Bitte erneut über FUNDIO CONTROL öffnen."); return; }
    api.post("/support/session/exchange", { code })
      .then(() => { navigate("/dashboard", { replace: true }); })
      .catch((e) => { setState("error"); setMsg(formatApiError(e.response?.data?.detail) || "Support-Zugang fehlgeschlagen."); });
  }, [ended, navigate]);

  return (
    <div className="dark flex min-h-screen items-center justify-center bg-fundio-dark px-4" style={{ fontFamily: '"Satoshi", sans-serif' }}>
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white/[0.03] p-8 text-center" data-testid="support-enter-card">
        {state === "working" && (
          <>
            <Loader2 className="mx-auto h-9 w-9 animate-spin text-fundio-gold" />
            <h1 className="mt-5 text-[20px] font-black text-white">Support-Ansicht wird geöffnet…</h1>
            <p className="mt-2 text-[13.5px] text-white/60">Sichere Super-Admin-Session wird verifiziert.</p>
          </>
        )}
        {state === "ended" && (
          <>
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-fundio-gold/15"><ShieldCheck className="text-fundio-gold" size={24} /></span>
            <h1 className="mt-5 text-[20px] font-black text-white" data-testid="support-ended-title">Support-Ansicht beendet</h1>
            <p className="mt-2 text-[13.5px] text-white/60">Die Super-Admin-Ansicht wurde beendet oder ist abgelaufen. Es besteht kein weiterer Zugriff auf Kundendaten.</p>
            <a href="/login" className="mt-6 inline-flex items-center gap-2 rounded-lg bg-fundio-gold px-4 py-2.5 text-[13.5px] font-bold text-fundio-black" data-testid="support-ended-login">
              Zum Login <ArrowRight size={15} />
            </a>
          </>
        )}
        {state === "error" && (
          <>
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-500/15"><XCircle className="text-red-400" size={24} /></span>
            <h1 className="mt-5 text-[20px] font-black text-white" data-testid="support-error-title">Zugang nicht möglich</h1>
            <p className="mt-2 text-[13.5px] text-white/60" data-testid="support-error-msg">{msg}</p>
            <a href="/login" className="mt-6 inline-flex items-center gap-2 rounded-lg border border-white/20 px-4 py-2.5 text-[13.5px] font-semibold text-white">Zum Login</a>
          </>
        )}
      </div>
    </div>
  );
}
